export default __webpack_public_path__ + "static/media/The Twinned Moons.35c84a3b.jpg";